/**
 * 管理端 MQTT WebSocket（与小程序 utils/mqttWS.js 协议一致）
 * 连接后发送 {"action":"subscribe","topic":"/v2/EM/xxx/rx"}
 */

function getWsBaseUrl() {
  const env = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_BASE;
  const base = (env && String(env).trim()) || 'https://paizhao.yunjiaozu.com';
  return base.replace(/^http/i, (m) => (m.toLowerCase() === 'https' ? 'wss' : 'ws'));
}

/**
 * @param {string} topic primary rx
 * @param {(topic: string, message: string, messageHex?: string) => void} onMessage
 * @param {{ extraRxTopics?: string[], onClose?: () => void }} [options]
 * @returns {{ close: function, ready: Promise<void> }}
 */
export function createMqttWS(topic, onMessage, options = {}) {
  const extraRxTopics = Array.isArray(options.extraRxTopics) ? options.extraRxTopics : [];
  const onCloseCb = typeof options.onClose === 'function' ? options.onClose : null;
  const url = `${getWsBaseUrl()}/api/mqtt/ws`;
  let socket = null;
  let closed = false;
  let resolveReady;
  let rejectReady;
  const ready = new Promise((resolve, reject) => {
    resolveReady = resolve;
    rejectReady = reject;
  });

  const send = (obj) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(obj));
    }
  };

  const subscribeAll = () => {
    const primary = String(topic || '').trim();
    if (primary) send({ action: 'subscribe', topic: primary });
    for (let i = 0; i < extraRxTopics.length; i++) {
      const t = String(extraRxTopics[i] || '').trim();
      if (t && t !== primary) send({ action: 'subscribe', topic: t });
    }
  };

  try {
    socket = new WebSocket(url);
  } catch (e) {
    rejectReady(e);
    return { close: () => {}, ready: Promise.reject(e) };
  }

  socket.onopen = () => {
    subscribeAll();
    resolveReady();
  };
  socket.onerror = () => {
    if (onCloseCb) onCloseCb();
    rejectReady(new Error('WebSocket 连接失败'));
  };
  socket.onclose = () => {
    if (onCloseCb) onCloseCb();
  };
  socket.onmessage = (ev) => {
    try {
      const data = JSON.parse(ev.data);
      const t = data.topic || topic;
      const msg = data.message != null ? String(data.message) : '';
      const hex = data.messageHex != null ? String(data.messageHex) : msg;
      if (typeof onMessage === 'function') onMessage(t, msg, hex);
    } catch (_) {}
  };

  const close = () => {
    if (closed) return;
    closed = true;
    try {
      if (socket && socket.readyState === WebSocket.OPEN) socket.close();
    } catch (_) {}
    socket = null;
  };

  return { close, ready };
}
